/**
 * Slider Component
 *
 * @file slider.js
 */

import $ from "jquery";
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay, EffectCoverflow, EffectFade, Controller, Thumbs  } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectCoverflow, EffectFade, Controller, Thumbs ]);

import 'swiper/swiper-bundle.css';
import 'swiper/swiper-bundle.min.js';
import 'swiper/components/effect-coverflow/effect-coverflow.min.css';
import 'swiper/components/effect-fade/effect-fade.min.css';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    const swiper = new Swiper('.main-slider', {
      effect: "fade",
      pagination: {
        el: ".home-slider-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".home-slider-next",
        prevEl: ".home-slider-prev",
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });
  };
  
  const slidePageScrollBottom = () => {
    $(".home-page-scroll-to-bottom").on("click", function(){
      $("html,body").animate({
          scrollTop: $(window).innerHeight() - $("header").innerHeight()
      }, 500);
    });
  };

  const newsSlider = () => {
    const swiperNews = new Swiper('.home-news-accordion-list', {
      slidesPerView: 3.5,
      spaceBetween: 40,
      loop:true,
      navigation: {
        nextEl: ".hm-news-next",
        prevEl: ".hm-news-prev ",
      },
      breakpoints: {
        0: {
          spaceBetween: 15,
          slidesPerView: 1.4,
          allowTouchMove: true,
        },
        680: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3.5,
          spaceBetween: 30,
        },
        1300: {
          slidesPerView: 3.5,
          spaceBetween: 40,
        },
        1640: {
          slidesPerView: 3.5,
          spaceBetween: 40,
        },
      }
    });
  }

  const homeHistorySlider = () => {
    const historySlider = new Swiper('.history-number-carousel', {
      spaceBetween: 10,
      slidesPerView: 12,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        0: {
          spaceBetween: 10,
          slidesPerView: 6,
          allowTouchMove: true,
        },
        680: {
          spaceBetween: 10,
          slidesPerView: 9,
        },
        992: {
          spaceBetween: 10,
          slidesPerView: 10,
        },
        1640: {
          spaceBetween: 10,
          slidesPerView: 12,
        },
      }
    });
    const historyThumbSlider = new Swiper('.home-our-history-carousel', {
      effect: "fade",
      spaceBetween: 0,
      navigation: {
        nextEl: ".hm-hs-next",
        prevEl: ".hm-hs-prev",
      },
      thumbs: {
        swiper: historySlider,
      },
    });
  }

  const commoditiesCSlider = () => {
    const commoditiesCSlider = new Swiper('.home-commodities-carousel', {
      slidesPerView: 4.5,
      spaceBetween: 35,
      loop:true,
      navigation: {
        nextEl: ".hm-com-next",
        prevEl: ".hm-com-prev ",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
          allowTouchMove: true,
        },
        680: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3.3,
          spaceBetween: 20,
        },
        1300: {
          slidesPerView: 3.5,
          spaceBetween: 30,
        },
        1640: {
          slidesPerView: 4.5,
          spaceBetween: 35,
        },
      }
    });
  }

  const homeReferencesSlider = () => {
    const homeReferencesSlider = new Swiper('.home-ref-carousel', {
      slidesPerView: 9.5,
      spaceBetween: 15,
      centeredSlides:true,
      loop:true,
      navigation: {
        nextEl: ".hm-news-next",
        prevEl: ".hm-news-prev ",
      },
      breakpoints: {
        0: {
          spaceBetween: 0,
          slidesPerView: 2,
          allowTouchMove: true,
          spaceBetween: 40,
        },
        680: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: 5,
          spaceBetween: 15,
        },
        1280: {
          slidesPerView: 6,
          spaceBetween: 15,
        },
        1640: {
          slidesPerView: 9.5,
          spaceBetween: 15,
        },
      }
    });
  }

  const init = () => {
    fullSlider();
    newsSlider();
    homeHistorySlider();
    commoditiesCSlider();
    homeReferencesSlider();
    slidePageScrollBottom();
  };

  return {
    init,
  };
})();

export default slider;
